import AppConfigs from "../Config/AppConfig";
import { list } from "./Apis";
import { Storage } from "aws-amplify";

// List products api
export async function listProducts(query = {}) {
  let result = await list(AppConfigs["entityNames"]["products"], query);
  let productsData = result.data;
  if (productsData.products) {
    productsData.products["Bulk Gravel"] &&
      productsData.products["Bulk Gravel"].map(async (product, index) => {
        product["image"] = await Storage.get(product?.["images"]?.[0]);
      });
    productsData.products["Palletized Stone"] &&
      productsData.products["Palletized Stone"].map(async (product, index) => {
        product["image"] = await Storage.get(product?.["images"]?.[0]);
      });
  }
  return productsData;
  // .then(result => {
  //     if (result.success) {
  //         this.setState({
  //             pageLoading: false,
  //             productsData: result.data.sort((a,b) => a.productName > b.productName ? 1 : -1)
  //         })
  //     } else {
  //         console.log(result.errors);
  //         this.setState({
  //             pageLoading: false
  //         })
  //     }
  // });
}
